import React, { useEffect } from "react";
import { Col, Empty, Row } from "antd";
import "./styles.css";

import { useConfig } from "../../data/useConfig";
import { useFilters } from "../../data/useFilters";
import { useSearchResults } from "../../data/useSearchResults";

import {
  dispatchGA4SearchEvent,
  dispatchSearchRefreshEvent,
} from "../../utils/events";
import { handleEventSearchProductClick } from "../../utils/helpers";

import Item from "../Item";
import Pagination from "../Pagination";
import SkeletonResults from "./Skeleton";

const ResultsPage = () => {
  const { isLoading, data } = useSearchResults();
  const { isLoading: isLoadingFilters, search, error, anchor } = useFilters();
  const { resultsLayoutMode } = useConfig();

  const handleClickItem = (item, event) => {
    handleEventSearchProductClick({
      term: search.input,
      productLabel: item.name || item.product_id,
    });

    const isHit = event?.target?.closest("a");
    if (isHit) {
      dispatchGA4SearchEvent({
        eventAction: "hit",
        eventLabel: search?.input,
        eventValue: `${item?.name} (${item?.sku})`,
      });
    }
  };

  useEffect(() => {
    dispatchSearchRefreshEvent(data);
  }, [data]);

  if (isLoading || isLoadingFilters) return <SkeletonResults />;

  if (error)
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description="Ops, deu errado :("
      />
    );

  return (
    <div className="beon-showcase--search-container">
      {data?.results.length > 0 && (search.input || anchor) && (
        <Row
          className={`beon-showcase--grid beon-showcase--default beon-showcase--search beon-showcase--${resultsLayoutMode}`}
          gutter={[0, 12]}
          style={{ display: "flex", justifyContent: "flex-start" }}
        >
          {data.results.map((item, index) => (
            <Col xs={12} md={8} key={index}>
              <Item item={item} handleClick={handleClickItem} />
            </Col>
          ))}
        </Row>
      )}
      <Pagination />
    </div>
  );
};

export default ResultsPage;
